/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "animation_default": "animate-spin animate-ease-in-out",
  "animation_alternative": "animate-pulse",
  "colors_default": "",
  "size_default": "h-16 w-16 mx-auto",
  "variant_default": "flex items-center justify-center relative"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Loader");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;